(function () {
  "use strict";

  function lockAgeGate(gate) {
    var box = gate.querySelector("[data-product-age]");

    if (!box) {
      return;
    }

    function apply() {
      gate.classList.toggle("is-confirmed", box.checked);
    }

    box.addEventListener("change", apply);
    gate.addEventListener(
      "click",
      function (event) {
        var btn = event.target.closest(".fishkill-atc, .single_add_to_cart_button");

        if (btn && !box.checked) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
    gate.addEventListener(
      "submit",
      function (event) {
        if (!box.checked) {
          event.preventDefault();
        }
      },
      true
    );
    apply();
  }

  function amountFromHtml(html) {
    var wrap = document.createElement("div");
    var node;

    wrap.innerHTML = html || "";
    node = wrap.querySelector(".price");

    if (node) {
      return node.innerHTML;
    }

    node = wrap.querySelector(".woocommerce-Price-amount");

    return node ? node.outerHTML : "";
  }

  function paintIntroPrice(price, amountInner) {
    var options = price.querySelector(":scope > .product-intro__options");
    var span;

    Array.prototype.slice.call(price.children).forEach(function (node) {
      if (node !== options) {
        node.remove();
      }
    });

    if (!amountInner) {
      return;
    }

    span = document.createElement("span");
    span.className = "price";
    span.innerHTML = amountInner;

    if (options) {
      price.insertBefore(span, options);
    } else {
      price.appendChild(span);
    }
  }

  function selectedPackQty(intro) {
    var selected = intro.querySelector(".product-pack__option.is-selected");
    var qty = selected ? parseInt(selected.getAttribute("data-pack-qty"), 10) : 1;

    return qty > 0 ? qty : 1;
  }

  function applyPackQty(intro) {
    var form = intro.querySelector("form.cart, form.variations_form");
    var input = form ? form.querySelector("input.qty") : null;

    if (!input) {
      return;
    }

    input.value = String(selectedPackQty(intro));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function paintIntroStock(intro, html) {
    var stock = intro.querySelector(".product-intro__stock");

    if (!stock) {
      return;
    }

    stock.innerHTML = (html || "").replace(/(>)\s*\d[\d.,]*\s+/, "$1");
  }

  function selectPack(intro, button) {
    intro.querySelectorAll(".product-pack__option").forEach(function (other) {
      var on = other === button;

      other.classList.toggle("is-selected", on);
      other.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function cartConfig() {
    return window.fishkillRecipeCta || null;
  }

  function selectedProductId(form) {
    var variation = form.querySelector("input.variation_id");
    var variationId = variation ? parseInt(variation.value, 10) : 0;

    if (variationId > 0) {
      return variationId;
    }

    var product = form.querySelector('[name="add-to-cart"]');

    return product ? parseInt(product.value, 10) || 0 : 0;
  }

  function parentProductId(form) {
    var product = form.querySelector('[name="product_id"], [name="add-to-cart"]');

    return product ? String(parseInt(product.value, 10) || "") : "";
  }

  function selectedPurchase(form) {
    var subscribe = form.querySelector('input[name="subscribe-to-action-input"]:checked');
    var parentId = parentProductId(form);
    var select;
    var radio;

    if (!subscribe || subscribe.value !== "yes") {
      return { subscribe: "no", scheme: "" };
    }

    select = form.querySelector('select[name="convert_to_sub_dropdown' + parentId + '"]');
    radio = form.querySelector('input[name="convert_to_sub_' + parentId + '"]:checked');

    return {
      subscribe: "yes",
      scheme: select && select.value ? select.value : radio ? radio.value : "",
    };
  }

  function ageBlocked(intro) {
    var gate = intro.querySelector("[data-product-age-gate]");
    var box = gate ? gate.querySelector("[data-product-age]") : null;

    return !!(box && !box.checked);
  }

  function paintStoreCart(cart, addId) {
    var config = cartConfig();
    var items = cart && cart.items ? cart.items : [];
    var next = {};
    var count = cart && typeof cart.items_count === "number" ? cart.items_count : 0;
    var i;
    var line;

    for (i = 0; i < items.length; i += 1) {
      next[String(items[i].id)] = {
        key: items[i].key || "",
        qty: Number(items[i].quantity) || 0,
      };
      if (!(cart && typeof cart.items_count === "number")) {
        count += Number(items[i].quantity) || 0;
      }
    }

    if (config) {
      config.cartLines = next;
    }

    document.querySelectorAll("[data-cart-count]").forEach(function (node) {
      node.textContent = String(count);
    });

    line = next[String(addId)] || { qty: 0, key: "" };
    document.querySelectorAll("[data-fishkill-cart]").forEach(function (root) {
      if (Number(root.dataset.addId) !== addId || typeof root._fishkillRender !== "function") {
        return;
      }

      root._fishkillRender(line.qty, line.key);
    });
  }

  function submitIntroCart(intro) {
    var config = cartConfig();
    var form = intro.querySelector("form.cart, form.variations_form");
    var native;
    var addId;
    var purchase;
    var headers;

    if (!form || !config || !config.storeApi || intro.getAttribute("data-cart-pending") === "1") {
      return;
    }

    if (ageBlocked(intro)) {
      return;
    }

    native = form.querySelector(".single_add_to_cart_button");

    if (!native || native.disabled) {
      return;
    }

    applyPackQty(intro);
    addId = selectedProductId(form);

    if (addId < 1) {
      return;
    }

    purchase = selectedPurchase(form);
    headers = {
      "Content-Type": "application/json",
      Nonce: config.nonce || "",
    };

    if (config.cartToken) {
      headers["Cart-Token"] = config.cartToken;
    }

    intro.setAttribute("data-cart-pending", "1");
    intro.querySelectorAll("[data-fishkill-cart] .fishkill-atc, [data-fishkill-cart] [data-fishkill-minus], [data-fishkill-cart] [data-fishkill-plus]").forEach(function (button) {
      button.disabled = true;
    });

    fetch(config.storeApi.replace(/\/$/, "") + "/cart/add-item", {
      method: "POST",
      credentials: "same-origin",
      headers: headers,
      body: JSON.stringify({
        id: addId,
        quantity: selectedPackQty(intro),
        fishkill_subscribe: purchase.subscribe,
        fishkill_scheme: purchase.scheme,
      }),
    })
      .then(function (res) {
        var nextNonce = res.headers.get("Nonce");
        var nextToken = res.headers.get("Cart-Token");

        if (nextNonce) {
          config.nonce = nextNonce;
        }
        if (nextToken) {
          config.cartToken = nextToken;
        }

        if (!res.ok) {
          throw new Error("cart");
        }

        return res.json();
      })
      .then(function (cart) {
        paintStoreCart(cart, addId);
      })
      .catch(function () {
        var root = intro.querySelector("[data-fishkill-cart]");

        if (root && typeof root._fishkillRender === "function") {
          root._fishkillRender(Number(root.dataset.qty) || 0, root.dataset.cartKey || "");
        }
      })
      .finally(function () {
        intro.removeAttribute("data-cart-pending");
      });
  }

  function layoutSubscribe(intro) {
    var form = intro.querySelector("form.cart, form.variations_form");
    var panel;
    var wrapper;
    var perks;
    var action;

    if (!form) {
      return;
    }

    form.querySelectorAll("select.wcsatt-options-product-dropdown").forEach(function (select) {
      select.classList.add("fk-dropdown");
    });

    if (typeof window.initFkDropdowns === "function") {
      window.initFkDropdowns();
    }

    action = form.querySelector(
      ".wcsatt-options-prompt-label-subscription .wcsatt-options-prompt-action"
    );

    if (action && action.textContent !== "Subscribe & Save") {
      action.textContent = "Subscribe & Save";
    }

    panel = form.querySelector(".product-intro__sub-panel");
    wrapper = form.querySelector(".wcsatt-options-product-wrapper");

    if (!panel || !wrapper || panel.contains(wrapper)) {
      return;
    }

    perks = panel.querySelector(".product-intro__sub-perks");

    if (perks) {
      panel.insertBefore(wrapper, perks);
      return;
    }

    panel.appendChild(wrapper);
  }

  function bindSubscribeLayout(intro) {
    var form = intro.querySelector("form.cart, form.variations_form");

    layoutSubscribe(intro);

    if (!form || !window.jQuery) {
      return;
    }

    window.jQuery(form).on("show_variation", function () {
      window.setTimeout(function () {
        layoutSubscribe(intro);
      }, 0);
    });
  }

  function syncPills(intro) {
    var form = intro.querySelector("form.variations_form");
    var price = intro.querySelector(".product-intro__price");

    if (!form || !window.jQuery) {
      return;
    }

    intro.querySelectorAll(".product-card__pill").forEach(function (pill) {
      pill.addEventListener("click", function () {
        var key = pill.getAttribute("data-attribute");
        var row = pill.closest(".product-card__option-row");
        var select = form.querySelector('select[name="' + key + '"]');

        if (row) {
          row.querySelectorAll(".product-card__pill").forEach(function (other) {
            var on = other === pill;
            other.classList.toggle("is-selected", on);
            other.setAttribute("aria-pressed", on ? "true" : "false");
          });
        }

        if (price) {
          var current = price.querySelector(":scope > .price");
          paintIntroPrice(price, current ? current.innerHTML : "");
        }

        if (!select) {
          return;
        }

        select.value = pill.getAttribute("data-value") || "";
        window.jQuery(select).trigger("change");
      });
    });

    window.jQuery(form).on("found_variation", function (event, variation) {
      if (!variation) {
        return;
      }

      paintIntroStock(intro, variation.availability_html || "");

      if (!price) {
        return;
      }

      paintIntroPrice(price, amountFromHtml(variation.price_html));
    });

    window.jQuery(form).on("reset_data", function () {
      paintIntroStock(intro, "");

      if (!price) {
        return;
      }

      paintIntroPrice(price, "");
    });
  }

  function initPack(intro) {
    intro.querySelectorAll(".product-pack__option").forEach(function (button) {
      button.addEventListener("click", function () {
        selectPack(intro, button);
      });
    });
  }

  function initSubmit(intro) {
    var form = intro.querySelector("form.cart, form.variations_form");
    var addBtn = intro.querySelector("[data-fishkill-cart] .fishkill-atc");

    if (!form || !addBtn || addBtn.getAttribute("data-hero-pack") === "1") {
      return;
    }

    addBtn.setAttribute("data-hero-pack", "1");
    addBtn.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        submitIntroCart(intro);
      },
      true
    );
  }

  function init() {
    document.querySelectorAll("[data-product-age-gate]").forEach(lockAgeGate);
    document.querySelectorAll(".product-intro").forEach(function (intro) {
      syncPills(intro);
      initPack(intro);
      initSubmit(intro);
      bindSubscribeLayout(intro);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
